import Box from "ds/components/Box";
import Link from "ds/components/Link";
import Badge from "ds/components/Badge";

import { ApiKeyViewRoleBinding } from "../../types";

type ApiKeyRolesListItemNameCellProps = {
  roleBinding: ApiKeyViewRoleBinding;
};

const ApiKeyRolesListItemNameCell = ({ roleBinding }: ApiKeyRolesListItemNameCellProps) => {
  const roleUrl = `/settings/role/${roleBinding.role.id}`;

  return (
    <Box align="center" fullWidth gap="large">
      <Link size="small" variant="secondary" href={roleUrl}>
        {roleBinding.role.name}
      </Link>

      {roleBinding.role.isSystem && <Badge type="strong" variant="blue" text="SYSTEM" />}
    </Box>
  );
};

export default ApiKeyRolesListItemNameCell;
